

import firebase from 'firebase';
const firebaseConfig = {
  apiKey: "AIzaSyA2mbosQNKxSWdgNxY82rgpxE2wJTNAGzc",
  authDomain: "inotes-f00d3.firebaseapp.com",
  databaseURL: "https://inotes-f00d3-default-rtdb.firebaseio.com",
  projectId: "inotes-f00d3",
  storageBucket: "inotes-f00d3.appspot.com",
  messagingSenderId: "249042174401",
  appId: "1:249042174401:web:eeb908da56eefa530a6f40",
  measurementId: "G-V0S1ZSKTNL"
  };
firebase.initializeApp(firebaseConfig);
var storage = firebase.storage();
export default storage;